import { Component, OnInit } from '@angular/core';
import { TestDriveService } from '@services/test-drive.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TestDriveModel } from '@/models/test-drive/test-drive.model';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { saveAs } from 'file-saver';
import { LoggerService } from '@services/logger.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-test-drive-detail',
  templateUrl: './test-drive-detail.component.html',
  styleUrls: ['./test-drive-detail.component.scss'],
})
export class TestDriveDetailComponent implements OnInit {
  data: TestDriveModel;
  private id: number;
  isNewForm: boolean = false;
  protected readonly faFilePdf = faFilePdf;

  constructor(
    private testDriveService: TestDriveService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this.data = {} as TestDriveModel;
  }

  ngOnInit() {
    // Controlla se siamo nella route "new" guardando il path della route
    const routePath = this.route.snapshot.routeConfig?.path;
    if (routePath === 'test-drive/new') {
      this.isNewForm = true;
      this.data = {} as TestDriveModel;
      this.id = null;
      return;
    }

    // Altrimenti, siamo nella route detail/:id
    const idParam = this.route.snapshot.params['id'];

    if (!idParam) {
      this.isNewForm = true;
      this.data = {} as TestDriveModel;
      this.id = null;
      return;
    }

    // Verifica che sia un numero valido
    const id = Number(idParam);
    if (isNaN(id) || id <= 0) {
      this.toastr.error('ID test drive non valido.');
      this.router.navigate(['/test-drive']);
      return;
    }

    this.id = id;
    this.isNewForm = false;
    this.loadTestDrive(this.id);
  }

  private loadTestDrive(id: number) {
    this.testDriveService.getTestDriveById(id).subscribe({
      next: (testDrive: TestDriveModel) => {
        this.data = testDrive;
        // Se c'è una marca come oggetto, popola anche il campo visuale
        if (testDrive.marca && typeof testDrive.marca === 'object') {
          // Il form component gestirà il popolamento dei campi disabled
        }
      },
      error: (error) => {
        LoggerService.error('getTestDriveById failed!');
        LoggerService.error(error);
        this.toastr.error(`Errore durante il caricamento del test drive.`);
        this.router.navigate(['/test-drive']);
      },
      complete: () => LoggerService.log('Request done'),
    });
  }

  downloadPdf() {
    if (!this.id) {
      this.toastr.error('Impossibile scaricare il PDF: test drive non trovato.');
      return;
    }

    this.testDriveService.downloadPdf(this.id).subscribe({
      next: (response) => {
        saveAs(response, `Scarico-Responsabilita-${this.id}.pdf`);
        this.toastr.success('PDF scaricato correttamente!');
      },
      error: (error) => {
        LoggerService.error('downloadPdf failed!');
        LoggerService.error(error);
        this.toastr.error(`Errore durante il download del PDF.`);
      },
    });
  }

  showDownloadButton(): boolean {
    return !this.isNewForm && !!this.id;
  }
}
